import { renderRoutes } from 'react-router-config'
import React, { useEffect, useCallback, useMemo } from 'react'
import { FacebookProvider } from 'react-facebook'
import { useQuery } from 'react-query'
import useAuth from './reservation/hooks/useAuth'
import { get } from '@/pages/hmt/reservation/official-site/utils/fetch'
import { authToken } from '@/utils/helper'
import { isPC } from '@/utils'
import {
  useStoreReducer,
  StoreContext,
  storeActionType,
  useMusicReducer,
  MusicContext,
  musicActionType,
} from '@/pages/hmt/context'
import '@/pages/sea/static/lib/joymaker-jssdk.min'
import { useTA } from './hooks'

/**
 * BaseLayout
 */
const BaseLayout = (props: React.PropsWithChildren<any>) => {
  const { route, children } = props
  const [store, dispatch] = useStoreReducer()
  const [musicStore, musicDispatch] = useMusicReducer()
  const { initTa } = useTA()
  const { fbLoginByToken } = useAuth()

  useEffect(() => {
    initTa?.()
  }, [initTa])

  const stopMusic = useCallback(() => {
    musicDispatch({
      type: musicActionType.MUSIC_STATUS,
      data: false,
    })
  }, [musicDispatch])

  const storeCtxValue = useMemo(() => ({ store, dispatch }), [dispatch, store])
  const musicCtxValue = useMemo(
    () => ({ ...musicStore, stopMusic, musicDispatch }),
    [musicDispatch, musicStore, stopMusic]
  )

  const { data } = useQuery<unknown, ReturnData | Error, ReturnData>(
    '/hmt/api/homepage',
    async () => get('/api/homepage'),
    {
      refetchOnWindowFocus: false,
      retry: false,
    }
  )

  useQuery<unknown, ReturnData | Error, ReturnData>(
    '/hmt/api/news-categories',
    async () => get('/api/news-categories'),
    {
      refetchOnWindowFocus: false,
      retry: false,
      onSuccess: (res) => {
        dispatch({
          type: storeActionType.UPDATE_NEWS_CATEGORIES,
          data: [
            {
              id: 0,
              name: '最新',
              weight: 0,
            },
            ...((res?.data?.news_categories as any[]) ?? []),
          ],
        })
      },
    }
  )

  useEffect(() => {
    if (authToken()) {
      dispatch({
        type: storeActionType.LOGIN_STATUS,
        data: true,
      })
    }
  }, [dispatch])

  useEffect(() => {
    dispatch({
      type: storeActionType.UPDATE_HOMEDATA,
      data: data?.data,
    })
  }, [data, dispatch])

  useEffect(() => {
    const { pathname, search } = window.location
    const path = pathname.slice(1).split('/') || []
    if ((path[0] === 'pc-site') !== isPC()) {
      window.location.replace(
        `/${path[0] === 'm-site' ? 'pc-site' : 'm-site'}/${path
          .slice(1)
          .join('/')}${search}`
      )
    }
  }, [])

  useEffect(() => {
    fbLoginByToken()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="layout-container">
      <FacebookProvider appId="1549318245440048" language="zh_TW">
        <StoreContext.Provider value={storeCtxValue}>
          <MusicContext.Provider value={musicCtxValue}>
            {renderRoutes(route.routes)}
            {children}
          </MusicContext.Provider>
        </StoreContext.Provider>
      </FacebookProvider>
    </div>
  )
}

export default React.memo(BaseLayout)
